import { Loading } from "@focus/focusUI";
import React, { Suspense } from "react";
const DerivativeField = React.lazy(() => import("./DerivativeField").then((module) => ({
    default: module.DerivativeField,
})));
export const Derivative = (props) => (React.createElement(Suspense, { fallback: React.createElement(Loading, null) },
    React.createElement(DerivativeField, Object.assign({}, props))));
//# sourceMappingURL=Derivative.js.map